import React, { memo, useCallback, useState, useEffect, useRef } from "react";
import { useCtx, useT } from "@al/next/al-ex";
import { Button } from "@al/akui-mobile";

import ErrorBlock from "~/components/ui/ErrorBlock";

import { updateState, TabKey } from "../../components/FixedTab/utils";
import SectionTitle from "../../components/SectionTitle";
import redux from "../../redux/helper";

import styles from "./styles.scss";
import { Props, SectionStatus } from "./types";

const Description: React.FC<Props> = (props) => {
  const ctx = useCtx();
  const t = useT();
  const { spuId, skuId } = props;
  const [status, setStatus] = useState(SectionStatus.Loading);
  const [detailDesc, setDetailDesc] = useState("");
  const wrapperRef = useRef<HTMLDivElement>(null);

  const getDesc = async (spuId: string, skuId?: string): Promise<void> => {
    setStatus(SectionStatus.Loading);
    const { success, data } = await ctx.store.dispatch(redux.actions.asyncGetProductDescription({ spuId, skuId }));
    if (success) {
      setDetailDesc(data.desc);
      setStatus(SectionStatus.Success);
    } else {
      setStatus(SectionStatus.Fail);
    }
  };

  useEffect(() => {
    spuId && getDesc(spuId, skuId);
  }, [spuId, skuId]);

  const onRefresh = useCallback(() => {
    spuId && getDesc(spuId, skuId);
  }, [props.spuId, skuId]);

  useEffect(() => {
    if (process.browser && wrapperRef.current) {
      updateState({ name: TabKey.Description, el: wrapperRef.current });
    }
  }, [wrapperRef.current]);

  if (status === SectionStatus.Loading) {
    return (
      <div className={styles.error_box} ref={wrapperRef}>
        <div className={styles.loading} />
      </div>
    );
  }

  return (
    <div ref={wrapperRef} className={styles.box}>
      <SectionTitle title={t("描述")} />
      {status === SectionStatus.Fail ? (
        <ErrorBlock
          buttons={
            <Button className={styles.btn} fill="outline" onClick={onRefresh}>
              {t("global:重新刷新")}
            </Button>
          }
        />
      ) : (
        // 商品描述
        // eslint-disable-next-line @typescript-eslint/naming-convention
        <div className={styles.description} dangerouslySetInnerHTML={{ __html: detailDesc }} />
      )}
    </div>
  );
};

export default memo(Description);
